import { render, staticRenderFns } from "./KobisiAdsView.vue?vue&type=template&id=64434d7d&scoped=true&"
import script from "./KobisiAdsView.vue?vue&type=script&lang=js&"
export * from "./KobisiAdsView.vue?vue&type=script&lang=js&"
import style0 from "./KobisiAdsView.vue?vue&type=style&index=0&id=64434d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64434d7d",
  null
  
)

export default component.exports